import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import AtmpXb from "@/pages/AtmpXb";

export const Route = createFileRoute("/en/about-qbd/projects/atmp-xb")({
  head: () => buildRouteHead("/en/about-qbd/projects/atmp-xb"),
  component: AtmpXb,
});

